export default "__VITE_ASSET__BdxrDYqk__"